import { apiFetch } from './client';

/**
 * The audit trail — what the runtime did, per instance.
 *
 * `session_id` is the empty string, not null, for an event that belongs
 * to no session (`instance.spawned` is the common one). That is the
 * store's convention and is preserved rather than normalised, because a
 * reader filtering by session needs to tell "no session" from "a session
 * whose id I do not have".
 */

export interface AuditEvent {
  id: number;
  session_id: string;
  class_id: string;
  instance_id: string;
  timestamp_ms: number;
  event_type: string;
  summary: string;
  detail: Record<string, unknown> | null;
  trace_id: string | null;
}

export interface AuditQuery {
  limit?: number;
  class_id?: string;
  instance_id?: string;
  event_type?: string;
  session_id?: string;
}

export function fetchAuditEvents(q: AuditQuery = {}): Promise<AuditEvent[]> {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v !== undefined && v !== '') params.set(k, String(v));
  }
  const qs = params.toString();
  return apiFetch<AuditEvent[]>(`/api/audit/events${qs ? `?${qs}` : ''}`);
}
